var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "modal-submit-drafts",
      attrs: {
        name: "modalChangeTimeEvent",
        width: "35%",
        height: "auto",
        scrollable: true
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c(
        "div",
        { staticClass: "modal-header border-0 justify-content-end pb-0" },
        [
          _c(
            "div",
            {
              staticClass: "modal-close-img",
              on: {
                click: function($event) {
                  _vm.onCancel()
                },
                mouseover: function($event) {
                  _vm.isHoverClose = true
                },
                mouseleave: function($event) {
                  _vm.isHoverClose = false
                }
              }
            },
            [
              !_vm.isHoverClose
                ? _c("img", {
                    staticClass: "cursor-pointer",
                    attrs: {
                      src: require("../../../static/img/info-modal-close.svg"),
                      alt: "close"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isHoverClose
                ? _c("img", {
                    staticClass: "cursor-pointer",
                    attrs: {
                      src: require("../../../static/img/info-modal-close-hover.svg"),
                      alt: "close"
                    }
                  })
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "main-content" }, [
        _c("p", { staticClass: "text-question" }, [
          _vm._v(
            "Are you sure you want to change event start/end time? All scheduled appointments within this event will be canceled."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-description" }, [
          _c("b", [_vm._v("Members will receive a cancellation email.")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn-container" },
          [
            _c(
              "b-button",
              { staticClass: "btn-cancel", on: { click: _vm.onCancel } },
              [_vm._v("\n        Cancel\n      ")]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "btn-submit",
                attrs: { disabled: _vm.loading },
                on: { click: _vm.onSubmit }
              },
              [
                _vm.loading ? _c("b-spinner") : _vm._e(),
                _vm._v("\n        Submit\n      ")
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0c6a0b9c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c6a0b9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/ModalChangeTimeEvent.vue
// module id = 1672
// module chunks = 1